import {BehaviorSubject} from "rxjs";
import {LayoutID} from "./device-type.model";

const types = {
  meter: {
    name: 'meter',
    icon: 'offline_bolt'
  },
  datalogger: {
    name: 'datalogger',
    icon: 'settings_remote'
  },
  site: {
    name: 'site',
    icon: 'business'
  },
  company: {
    name: 'company',
    icon: 'apartment'
  },
  interface: {
    name: 'interface',
    icon: 'settings_ethernet'
  },
  universalMeter: {
    name: 'universal_meter',
    icon: 'bolt'
  },
  impulseMeter: {
    name: 'impulse_meter',
    icon: 'waves'
  },
  other: {
    name: 'other',
    icon: 'help_center'
  },
};

export class NodeModel {
  public name?: string;
  public type?: string;
  public icon?: string;
  public children?: BehaviorSubject<NodeModel[]>;

  public id?: number;
  public target?: string;
  public offset?: number;
  public start?: string;
  public end?: string;

  public device?: any;
  public deviceid?: number;
  public deviceLayout?: number;
  public site?: any;
  public siteid?: number;
  public company?: any;
  public companyid?: number;
  public companyrole?: string;
  public message?: string;

  public parent?: number;

  public modified?: string;
  public modifiedBy?: string;

  constructor (data?: any) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.target = data.target;
      this.start = data.start;
      this.end = data.end;
      this.device = data.device;
      this.deviceid = data.deviceid;
      this.target = data.target;
      this.offset = data.offset;
      this.site = data.site;
      this.siteid = data.siteid;
      this.parent = data.parent;
      this.deviceLayout = data.deviceLayout;

      this.company = data.company;
      this.companyid = data.companyid;
      this.companyrole = data.companyrole;
      this.modified = data.modified;
      this.modifiedBy = data.modifiedBy;

      this.type = data.type;
      this.icon = data.icon;
      if (data.deviceid) {
        this.name = data.device;

        switch (+data.deviceLayout) {
          case LayoutID.DataLogger:
            this.type = types.datalogger.name;
            this.icon = types.datalogger.icon;
            break;
          case LayoutID.ElectricityMeter:
            this.type = types.meter.name;
            this.icon = types.meter.icon;
            break;
          case LayoutID.Interface:
            this.type = types.interface.name;
            this.icon = types.interface.icon;
            break;
          case LayoutID.UniversalElectricityMeter:
            this.type = types.universalMeter.name;
            this.icon = types.universalMeter.icon;
            break;
          case LayoutID.ImpulseMeter:
            this.type = types.impulseMeter.name;
            this.icon = types.impulseMeter.icon;
            break;
          default:
            this.type = types.other.name;
            this.icon = types.other.icon;
        }
      } else if (data.postalCode) {
        this.type = types.site.name;
        this.icon = types.site.icon;
      } else {
        this.type = types.company.name;
        this.icon = types.company.icon;
      }

      let childs = [];
      if (data.children && data.children.length) {
        childs = data.children.map(child => new NodeModel(child))
      }

      let sites = [];
      if (data.sites && data.sites.length) {
        sites = data.sites.map(child => new NodeModel(child))
      }

      let devices = [];
      if (data.devices && data.devices.length) {
        devices = data.devices.map(child => new NodeModel(child))
      }

      this.children = new BehaviorSubject([
        ...childs,
        ...sites,
        ...devices
      ]);
    }
  }

  isCompany() {
    return this.type === types.company.name;
  }

  isSite() {
    return this.type === types.site.name;
  }

  isMeter() {
    return this.type === types.meter.name || this.type == types.universalMeter.name || this.type == types.impulseMeter.name;
  }

  isDatalogger() {
    return this.type === types.datalogger.name || this.type == types.interface.name
  }

  isDevice() {
    return this.isMeter() || this.isDatalogger();
  }

  addChild(child: NodeModel): void {
    this.children.next([...this.children.getValue(), child]);
  }

}
